/**
 * Модель документа.
 *
 * @summary Часть свойств получается со стороны сервера и расширяет текущую модель.
 * @see NpoComputer.WebAccess.Models.EDocumentModel
 */
var DocumentModel = BaseObjectModel.extend({
  className: "DocumentModel",

  /**
  * Выполняет прикладной метод.
  * @function DocumentModel.executeEntityMethod
  * @param {string} methodName Имя метода.
  * @param {object[]} opt_parameters Параметры, с которыми должен вызываться метод.
  * @since 5.5.0.1000
  
  * @example 
  * WebAccess.current.executeEntityMethod('MethodName', new WA.Link()).done(function(result) { console.log(result); });
  */
  executeEntityMethod: function (methodName, opt_parameters) {
    var d = $.Deferred();
    var me = this;
    var parameters = Array.prototype.slice.call(arguments, 1);

    WA.domainMethods.executeEntityMethod("/api/Document.asmx/ExecuteEntityMethod",
      this.ID, "", methodName, parameters).done(function (res) {
        var changes = res.Changes;
        var changedMultiSelects = res.ChangedMultiSelectRequisitesValues;
        if (me.form && me.form.isExist()) me.form.applyServerSideChanges(changes, changedMultiSelects);

        d.resolve(res.MethodResult);
      }).fail(function (errorMessage, res) {
        if (res) {
          if (res.Result) {
            var data = res.Result;
            var changes = data.Changes;
            var changedMultiSelects = data.ChangedMultiSelectRequisitesValues;
            if (me.form && me.form.isExist()) me.form.applyServerSideChanges(changes, changedMultiSelects);
          }
          d.reject(res.Error);
        } else {
          d.reject(errorMessage);
        }
      });

    return d.promise();
  },

  /**
   * Проверяет, доступен ли метод для текущего документа.
   * @function DocumentModel.isMethodAvailable
   * @param {string} methodName Имя метода.
   * @return {boolean} True – прикладной метод доступен для текущего документа, иначе False.
   * @since 5.5.0.1000
   */
  isMethodAvailable: function (methodName) {
    return WA.domainMethods.isMethodAvailable("/api/Document.asmx/IsEntityMethodAvailable", this.ID, methodName);
  }
});